import React from 'react';
import styles from './M_Rate.module.css';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface M_RateProps {
  name: string;
  price: number;
  isDiscounted: boolean;
  discount: number;
  isActive: boolean;
  showPriceSuffix?: boolean;
}

export default function M_Rate({
  name,
  price,
  isDiscounted,
  discount,
  isActive,
  showPriceSuffix = true,
}: M_RateProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  return (
    <div className={cn(styles.wrapper, { [styles.active]: isActive })}>
      <span className={cn(styles.rate, 'text-p-7')}>{name}</span>
      {isDiscounted && (
        <div className={cn(styles.discount_wrapper, 'text-p-7')}>
          <span className={cn(styles.discount, 'text-p-7')}>
            <span className={cn(styles.discount_text, 'text-p-7')}>
              {t('payment.subscribePlan.discount')}
            </span>{' '}
            <span className={cn(styles.discount_number, 'text-p-7')}>
              {discount}%
            </span>
          </span>
        </div>
      )}
      <span className={cn(styles.price, 'text-p-7')}>
        {price} {showPriceSuffix ? t('payment.subscribePlan.priceSuffix') : '$'}
      </span>
    </div>
  );
}
